import { useState } from 'react'
import { useAsync } from 'react-async-hook'
import useConstant from 'use-constant'
import promiseDebounce from 'awesome-debounce-promise'
import { isCompleteAddress } from './helpers'
import GoogleClient from '@mortgage-pos/ui/services/GoogleClient'

import {
  GoogleAutoCompleteResult,
  GoogleApiStatusCode,
  UserLocation,
} from '@mortgage-pos/types'

export const useAddressFieldsAutoComplete = (userLocation: UserLocation) => {
  const [inputText, setInputText] = useState('')

  const debounced = useConstant(() =>
    promiseDebounce(GoogleClient.fetchAddressAutoComplete, 50)
  )

  const results = useAsync(async (): Promise<GoogleAutoCompleteResult> => {
    if (!inputText || inputText.length < 1) {
      return {
        predictions: [],
        status: GoogleApiStatusCode.ZeroResults,
      }
    }

    if (isCompleteAddress(inputText, results)) {
      return results.result
    }

    return debounced(inputText, userLocation)
  }, [inputText])

  return { inputText, setInputText, results }
}
